// https://raw.githubusercontent.com/dominictarr/random-name/master/first-names.json
// https://raw.githubusercontent.com/dominictarr/random-name/master/names.json

import { randInt } from "../../core/util/random";

export const r = (names:string[]) => {
    return () => {
        return names[~~(Math.random()*names.length)]
    }
}
export const randomFirstName   = r(require('./firstnames.json'));
export const randomLastName    = r(require('./lastnames.json'));
export const randomName = () => {
    return randomFirstName() + ' ' +randomLastName();
}
export const randomIdentity = () => {
    const firstName = randomFirstName()
    const lastName = randomLastName();
    return {
        firstName, lastName, 
        name: firstName+' '+lastName,
        email: firstName.toLowerCase()[0] + lastName.toLowerCase() + '@uni.ca'
    }
}

export const genericIdentity = (userType:string, lang?: string) => {
    const firstName = lang === 'fr' ? 'Exemple' : 'Sample';
    const lastName = userType+" "+randInt(1, 10000);
    return {
        firstName, lastName, 
        name: firstName+' '+lastName,
        email: firstName.toLowerCase()[0] + lastName.toLowerCase() + '@uni.ca'
    }
}

// var g = () => {
//     return names[~~(Math.random()*names.length)]
// }
// var arr = []
// for (var i=0; i<100; i++){
//     arr.push(g())
// }
// console.log(JSON.stringify(arr))